import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { toastError } from 'components/billing/common/utils';
import { useUser } from 'controllers/contexts/user';
import { api } from 'controllers/network/apiClient';
import { SUBSCRIBER_STATUS_CACHE_KEY } from './useSubscriberStatus';

export interface UpdateContactInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  customerSupportPhone?: string;
  consent?: boolean;
  referral?: string;
  installGoal?: string;
  industry?: string;
  agreedToTerms?: boolean;
  freeEmailAcknowledged?: boolean;
}

const UpdateContactInfoUrl = '/shop/update_contact_info';

export const updateContactInfo = async ({
  firstName,
  lastName,
  email,
  phone,
  customerSupportPhone,
  consent,
  referral,
  installGoal,
  industry,
}: UpdateContactInfo): Promise<void> => {
  await api.post(UpdateContactInfoUrl, {
    first_name: firstName,
    last_name: lastName,
    phone_number: phone,
    customer_support_phone_number: customerSupportPhone,
    sms_contact_consent: consent,
    source: referral,
    install_goal: installGoal,
    industry,
    email,
  });
};

export const useUpdateContactInfo = (): UseMutationResult<
  any,
  any,
  UpdateContactInfo
> => {
  const queryClient = useQueryClient();
  const { getUserInfo } = useUser();

  return useMutation(
    async (info: UpdateContactInfo) => {
      return updateContactInfo(info);
    },
    {
      onSuccess: () => {
        getUserInfo();
        queryClient.refetchQueries([SUBSCRIBER_STATUS_CACHE_KEY]);
      },
      onError: toastError,
    },
  );
};
